/**
 * Mirrors {@see TicketOpenQueueSort} for client-side list reorder after toolbar patches.
 */
const DEFAULT_TIER_RANK = 4;
const DEFAULT_PRIORITY_RANK = 3;

function tierRank(row) {
    const rank = row.queue_sort_tier_rank;
    return rank === undefined || rank === null ? DEFAULT_TIER_RANK : Number(rank);
}

function priorityRank(row) {
    if (row.queue_sort_priority_rank !== undefined && row.queue_sort_priority_rank !== null) {
        return Number(row.queue_sort_priority_rank);
    }
    const map = { high: 1, medium: 2, low: 3 };
    return map[row.priority] ?? DEFAULT_PRIORITY_RANK;
}

function createdAtMs(row) {
    if (!row.created_at) {
        return 0;
    }
    const ms = Date.parse(row.created_at);
    return Number.isNaN(ms) ? 0 : ms;
}

export function sortOpenQueueTickets(tickets) {
    return [...tickets].sort((left, right) => {
        const tierDiff = tierRank(left) - tierRank(right);
        if (tierDiff !== 0) {
            return tierDiff;
        }
        const priorityDiff = priorityRank(left) - priorityRank(right);
        if (priorityDiff !== 0) {
            return priorityDiff;
        }
        const createdDiff = createdAtMs(left) - createdAtMs(right);
        if (createdDiff !== 0) {
            return createdDiff;
        }
        return Number(left.id) - Number(right.id);
    });
}

export function priorityRankForValue(priority) {
    const map = { high: 1, medium: 2, low: 3 };
    return map[priority] ?? DEFAULT_PRIORITY_RANK;
}
